module.exports = __webpack_public_path__ + "static/media/animal-00.d4bf0639.png";